"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _AbstractDeviceFrame = _interopRequireDefault(require("./AbstractDeviceFrame"));

var _colors = require("HubStyleTokens/colors");

var _Styles = require("../utils/Styles");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-bottom-left-radius: inherit;\n  border-bottom-right-radius: inherit;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      ", " {\n        position: absolute; /* #6883 */\n        width: ", ";\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      height: ", ";\n      overflow: hidden;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border: 1px solid ", ";\n  border-radius: 6px;\n  ", ";\n  position: relative;\n\n  ", " {\n    border-bottom-left-radius: inherit;\n    border-bottom-right-radius: inherit;\n    margin-top: ", ";\n  }\n\n  ", "\n\n  &::before {\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n    border-top-left-radius: inherit;\n    border-top-right-radius: inherit;\n    content: '';\n    height: ", ";\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 1;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DEVICE_BORDER = _colors.BATTLESHIP;

var DesktopFrame = function DesktopFrame(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("defs", null, _react.default.createElement("path", {
    d: "M0 5.999A6 6 0 0 1 6.003 0h794.994A6 6 0 0 1 807 5.999V547a6 6 0 0 1-6.003 5.999H6.003A6 6 0 0 1 0 547.001V6z",
    id: "a"
  })), _react.default.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("ellipse", {
    fill: DEVICE_BORDER,
    cx: "21",
    cy: "15.996",
    rx: "4",
    ry: "3.996"
  }), _react.default.createElement("ellipse", {
    fill: DEVICE_BORDER,
    cx: "34",
    cy: "15.996",
    rx: "4",
    ry: "3.996"
  }), _react.default.createElement("ellipse", {
    fill: DEVICE_BORDER,
    cx: "47",
    cy: "15.996",
    rx: "4",
    ry: "3.996"
  })));
};

var DESKTOP_DEVICE_SPECS = {
  desktop: {
    Template: DesktopFrame,
    top: 32,
    right: 0,
    bottom: 0,
    left: 0,
    height: 555,
    width: 809
  }
};
var TITLEBAR_HEIGHT = DESKTOP_DEVICE_SPECS.desktop.top;
var COMPUTED_TOOLBAR_HEIGHT = TITLEBAR_HEIGHT / DESKTOP_DEVICE_SPECS.desktop.height * 100 + "%";

var setToolbarHeight = function setToolbarHeight(height) {
  return height ? (0, _Styles.toPx)(TITLEBAR_HEIGHT) : COMPUTED_TOOLBAR_HEIGHT;
};

var DesktopTemplate = (0, _styledComponents.default)(_AbstractDeviceFrame.default.defaultProps.Template).withConfig({
  displayName: "UIDeviceFrameDesktop__DesktopTemplate",
  componentId: "sc-1eqtry5-0"
})(_templateObject());
var DesktopInner = (0, _styledComponents.default)(_AbstractDeviceFrame.default.defaultProps.InnerWrapper).withConfig({
  displayName: "UIDeviceFrameDesktop__DesktopInner",
  componentId: "sc-1eqtry5-1"
})(_templateObject2());
var DesktopWrapper = (0, _styledComponents.default)(function (props) {
  var __height = props.height,
      rest = (0, _objectWithoutProperties2.default)(props, ["height"]);
  return _react.default.createElement(_AbstractDeviceFrame.default.defaultProps.OuterWrapper, rest);
}).withConfig({
  displayName: "UIDeviceFrameDesktop__DesktopWrapper",
  componentId: "sc-1eqtry5-2"
})(_templateObject3(), DEVICE_BORDER, function (props) {
  return props.height && (0, _styledComponents.css)(_templateObject4(), typeof props.height === 'number' ? (0, _Styles.toPx)(props.height) : props.height);
}, DesktopInner, function (props) {
  return props.height && (0, _Styles.toPx)(TITLEBAR_HEIGHT);
}, function (props) {
  return props.height && (0, _styledComponents.css)(_templateObject5(), DesktopTemplate, (0, _Styles.toPx)(DESKTOP_DEVICE_SPECS.desktop.width));
}, _colors.GYPSUM, DEVICE_BORDER, function (props) {
  return setToolbarHeight(props.height);
});
var DesktopContent = (0, _styledComponents.default)(function (props) {
  return _react.default.createElement(_AbstractDeviceFrame.default.defaultProps.ContentWrapper, props);
}).withConfig({
  displayName: "UIDeviceFrameDesktop__DesktopContent",
  componentId: "sc-1eqtry5-3"
})(_templateObject6());

var UIDeviceFrameDesktop = function UIDeviceFrameDesktop(props) {
  var children = props.children,
      className = props.className,
      contentClassName = props.contentClassName,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "contentClassName"]);
  return _react.default.createElement(_AbstractDeviceFrame.default, (0, _extends2.default)({}, rest, {
    className: className,
    contentClassName: contentClassName,
    ContentWrapper: DesktopContent,
    InnerWrapper: DesktopInner,
    OuterWrapper: DesktopWrapper,
    spec: DESKTOP_DEVICE_SPECS.desktop,
    Template: DesktopTemplate
  }), children);
};

UIDeviceFrameDesktop.propTypes = {
  children: _react.PropTypes.node.isRequired,
  contentClassName: _react.PropTypes.string,
  height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};
UIDeviceFrameDesktop.displayName = 'UIDeviceFrameDesktop';
var _default = UIDeviceFrameDesktop;
exports.default = _default;
module.exports = exports.default;